import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as echarts from 'echarts';
import { KpiCardComponent } from '../kpi-card/kpi-card.component';

@Component({
  selector: 'app-dashboard',
  imports: [KpiCardComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements AfterViewInit {
  @ViewChild('activityChart') activityChartRef!: ElementRef<HTMLDivElement>;
  @ViewChild('usageChart') usageChartRef!: ElementRef<HTMLDivElement>;

  constructor(public router: Router) {}

  kpis = [
    { icon: 'bi bi-diagram-3', iconBg: '#e8f1ff', iconColor: '#3b82f6', label: 'Total Tenants', value: '12', change: '2 this month' },
    { icon: 'bi bi-hdd-network', iconBg: '#eef2ff', iconColor: '#6366f1', label: 'Total Services', value: '18', change: '3 this month' },
    { icon: 'bi bi-people', iconBg: '#f3e8ff', iconColor: '#a855f7', label: 'Total Users', value: '156', change: '12 this month' },
    { icon: 'bi bi-person-check', iconBg: '#fde8ec', iconColor: '#ef4444', label: 'Active Users', value: '98', change: '8 this month' }
  ];

  mostUsedTenants = [
    { name: 'Averitas Pharma', users: 28 },
    { name: 'Biomedica Inc.', users: 21 },
    { name: 'HealthCore', users: 18 },
    { name: 'MedSync Global', users: 15 },
    { name: 'Lifeline Labs', users: 12 }
  ];

  recentActivity = [
    { activity: 'New user added', tenant: 'Averitas Pharma', user: 'Suraj Kumar', time: '13-08-2026 10:15 AM' },
    { activity: 'Service credential updated', tenant: 'Biomedica Inc.', user: 'John Doe', time: '13-08-2026 09:42 AM' },
    { activity: 'Role updated', tenant: 'HealthCore', user: 'Admin', time: '12-08-2026 05:30 PM' },
    { activity: 'SSO configured', tenant: 'MedSync Global', user: 'Suraj Kumar', time: '12-08-2026 04:20 PM' },
    { activity: 'Service added', tenant: 'Lifeline Labs', user: 'Admin', time: '12-08-2026 11:05 AM' }
  ];

  quickActions = [
    { icon: 'bi bi-people', title: 'Manage Tenants', subtitle: 'View and manage all tenants', route: '/tenants' },
    { icon: 'bi bi-gear', title: 'Global Settings', subtitle: 'Configure platform level settings', route: '' }
  ];

  ngAfterViewInit(): void {
    const activityChart = this.renderActivityChart();
    const usageChart = this.renderUsageChart();
    window.addEventListener('resize', () => {
      activityChart.resize();
      usageChart.resize();
    });
  }

  private renderActivityChart(): echarts.ECharts {
    const chart = echarts.init(this.activityChartRef.nativeElement);
    chart.setOption({
      color: ['#2563eb', '#93c5fd', '#dbeafe'],
      series: [{
        type: 'pie',
        radius: ['65%', '85%'],
        label: { show: false },
        data: [
          { name: 'Active', value: 7 },
          { name: 'Inactive', value: 3 },
          { name: 'New', value: 2 }
        ]
      }]
    });
    return chart;
  }

  private renderUsageChart(): echarts.ECharts {
    const chart = echarts.init(this.usageChartRef.nativeElement);
    const data = [
      { name: 'Import Service', value: 245 },
      { name: 'Export Service', value: 178 },
      { name: 'File Explorer', value: 132 },
      { name: 'QC Service', value: 95 },
      { name: 'Others', value: 64 }
    ];
    chart.setOption({
      grid: { left: 90, right: 30, top: 10, bottom: 10 },
      xAxis: { show: false },
      yAxis: {
        type: 'category',
        data: data.map(d => d.name).reverse(),
        axisLine: { show: false },
        axisTick: { show: false }
      },
      series: [{
        type: 'bar',
        data: data.map(d => d.value).reverse(),
        barWidth: 12,
        itemStyle: { color: '#3b82f6', borderRadius: 6 },
        label: { show: true, position: 'right' }
      }]
    });
    return chart;
  }
}
